var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCalendar224X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_calendar1_24x24",
    transform: "translate(148.998 -42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(-154.411 42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(5.413)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M119.328,258.65a.413.413,0,0,0-.418-.408h-1.458a.413.413,0,0,0-.418.408v1.426a.413.413,0,0,0,.418.409h1.458a.413.413,0,0,0,.418-.409Z",
    transform: "translate(-113.364 -249.929)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M215.963,258.65a.413.413,0,0,0-.417-.408h-1.458a.413.413,0,0,0-.418.408v1.426a.413.413,0,0,0,.418.409h1.458a.413.413,0,0,0,.417-.409Z",
    transform: "translate(-206.819 -249.929)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M312.592,258.65a.413.413,0,0,0-.418-.408h-1.458a.413.413,0,0,0-.418.408v1.426a.413.413,0,0,0,.418.409h1.458a.413.413,0,0,0,.418-.409Z",
    transform: "translate(-300.267 -249.929)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M119.328,355.283a.413.413,0,0,0-.418-.408h-1.458a.413.413,0,0,0-.418.408v1.425a.413.413,0,0,0,.418.408h1.458a.413.413,0,0,0,.418-.408Z",
    transform: "translate(-113.364 -343.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M215.963,355.283a.413.413,0,0,0-.417-.408h-1.458a.413.413,0,0,0-.418.408v1.425a.413.413,0,0,0,.418.408h1.458a.413.413,0,0,0,.417-.408Z",
    transform: "translate(-206.819 -343.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M312.592,355.283a.413.413,0,0,0-.417-.408h-1.458a.413.413,0,0,0-.418.408v1.425a.413.413,0,0,0,.418.408h1.458a.413.413,0,0,0,.417-.408Z",
    transform: "translate(-300.267 -343.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M19.987,54.149v1.9a1.589,1.589,0,0,1-1.62,1.551H17.345a1.6,1.6,0,0,1-1.632-1.551V54.142h-4.6v1.912a1.6,1.6,0,0,1-1.63,1.551H8.456a1.588,1.588,0,0,1-1.62-1.555v-1.9A1.445,1.445,0,0,0,5.413,55.56V66.726a1.447,1.447,0,0,0,1.467,1.42H19.946a1.449,1.449,0,0,0,1.467-1.42V55.56a1.445,1.445,0,0,0-1.426-1.411ZM19.513,66.03a.613.613,0,0,1-.188.436.633.633,0,0,1-.446.177H7.916a.633.633,0,0,1-.446-.177.613.613,0,0,1-.188-.436V60.263a.613.613,0,0,1,.188-.436.633.633,0,0,1,.446-.177H18.878a.633.633,0,0,1,.446.177.613.613,0,0,1,.188.436V66.03Z",
    transform: "translate(-5.413 -52.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M80.175,4.792h1.137a.618.618,0,0,0,.625-.611V.611A.618.618,0,0,0,81.313,0H80.175a.618.618,0,0,0-.625.611v3.57A.618.618,0,0,0,80.175,4.792Z",
    transform: "translate(-77.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M345.083,4.792h1.137a.618.618,0,0,0,.625-.611V.611A.618.618,0,0,0,346.221,0h-1.137a.618.618,0,0,0-.625.611v3.57A.618.618,0,0,0,345.083,4.792Z",
    transform: "translate(-333.313)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCalendar224X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_calendar2_24x24.66e4f5f278b76ad1062e19b3dc51bd71.svg";